import { lazy } from 'react';

const CustomInstallacio = lazy(() => import('./CustomInstallacio'));

export default CustomInstallacio;
